import AtelierViewPage from "@features/creation/ateliers/components/AtelierViewPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { Eye } from "lucide-react";

export const Route = createFileRoute("/_app/creation/ateliers/$id/view")({
  loader: requirePermission(PERMISSIONS.CREATION.ATELIERS.VIEW),
  staticData: {
    title: "Détail atelier",
    icon: Eye,
    permission: PERMISSIONS.CREATION.ATELIERS.VIEW,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: ViewAtelierPage,
});

function ViewAtelierPage() {
  const { id } = useParams({ from: "/_app/creation/ateliers/$id/view" });
  return <AtelierViewPage id={id} />;
}
